export default "__VITE_ASSET__BDz3jS6u__"